export const types = {
  SET_MUSIC_LINK_PAGES: "SET_MUSIC_LINK_PAGES",
  ADD_MUSIC_LINK_PAGE: "ADD_MUSIC_LINK_PAGE",
  UPDATE_MUSIC_LINK_PAGE: "UPDATE_MUSIC_LINK_PAGE",
  DELETE_MUSIC_LINK_PAGE: "DELETE_MUSIC_LINK_PAGE",
};

export const setMusicLinkPages = payload => ({
  type: types.SET_MUSIC_LINK_PAGES,
  payload,
});

export const addMusicLinkPage = payload => ({
  type: types.ADD_MUSIC_LINK_PAGE,
  payload,
});

export const updateMusicLinkPage = payload => ({
  type: types.UPDATE_MUSIC_LINK_PAGE,
  payload,
});

export const deleteMusicLinkPage = payload => ({
  type: types.DELETE_MUSIC_LINK_PAGE,
  payload,
});
